import { cache as reactCache } from 'react';

import pMemoize, { AnyAsyncFunction } from 'p-memoize';

// eslint-disable-next-line @typescript-eslint/ban-types
export function cache<CachedFunction extends AnyAsyncFunction>(fn: CachedFunction): CachedFunction {
  return reactCache ? reactCache(fn) : pMemoize(fn, { cacheKey: (args) => JSON.stringify(args) });
}
